import { URL_PREFIX } from 'ev-config/config';

export enum AdminPaths {
  Workflows = 'workflows',
  PagesFrontDoorBuilder = 'front_door_builder',
  PagesJourneyBuilderList = 'journey_builder',
  PagesJourneyBuilder = 'journeys/:id/builder',
  PagesDocuments = 'documents',
  PagesForms = 'forms',
  PagesFormEditor = 'form_editor',
  PagesDocumentEditor = 'document_editor',
  PagesClinical = 'clinical',
  PagesPatient = 'patient',
  PagesMessages = 'messages',
  PagesClinicalQueue = 'queue',
  PagesClinicalEmbeddedQueue = 'embedded_queue',
  PagesClinicalPatient = 'clinical_patient',
  PagesClinicalVisitHistory = 'visit_history',
  PagesClinicalScheduling = 'scheduling',
  PagesClinicalVisitDetails = 'clinical_visit_details',
  PagesPatientNavigationMenu = 'navigation_menu',
  PagesPatientVisitDetails = 'patient_visit_details',
  Customize = 'customize',
  Roles = 'roles',
  Users = 'physicians',
  Settings = 'settings',
  ConnectedDevices = 'connected_devices',
  VideoBackground = 'video_background',
  InterpreterServices = 'interpreter_services',
  TelephonyServices = 'telephony_services',
  PagesDashboard = 'dashboard',
  CdxModules = 'cdx_modules',
  InterpreterManagement = 'interpreter_management',
  InterpreterManagementVendors = 'vendors',
}

export const ADMIN_ROOT = `${URL_PREFIX}/app_admin`;
